var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fac-pill-container"},[_c('div',{staticClass:"pill",class:_vm.safariClass,attrs:{"tabindex":"0","role":"definition"}},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }